import { InjectedConnector } from '@web3-react/injected-connector'
import { WalletConnectConnector } from '@web3-react/walletconnect-connector'
import { BscConnector } from '@binance-chain/bsc-connector'
import { ethers } from 'ethers'
import getNodeUrl from './getRpcUrl'
import TronLinkConnector from './TronLinkConnector'
import EventEmitter from 'events'
import promiseRetry from 'promise-retry'

export const connectorLocalStorageKey = "connectorId";

export enum ConnectorNames {
  Injected = "injected",
  WalletConnect = "walletconnect",
  BSC = "bsc",
  TRON = "tron"
}

const POLLING_INTERVAL = 12000
const rpcUrl = getNodeUrl()
const chainId = parseInt(process.env.REACT_APP_CHAIN_ID, 10)

const injected = new InjectedConnector({ supportedChainIds: [chainId] })

const walletconnect = new WalletConnectConnector({
  rpc: { [chainId]: rpcUrl },
  bridge: 'https://pancakeswap.bridge.walletconnect.org/',
  qrcode: true,
  //pollingInterval: POLLING_INTERVAL,
})

const bscConnector = new BscConnector({ supportedChainIds: [chainId] })
const tronConnector = new TronLinkConnector({ supportedChainIds: [1, 2] })

export const connectorsByName: { [connectorName in ConnectorNames]: any } = {
  [ConnectorNames.Injected]: injected,
  [ConnectorNames.WalletConnect]: walletconnect,
  [ConnectorNames.BSC]: bscConnector,
  [ConnectorNames.TRON]: tronConnector,
}

export const getLibrary = (provider): ethers.providers.Web3Provider => {
  const library = new ethers.providers.Web3Provider(provider)
  library.pollingInterval = POLLING_INTERVAL
  return library
}

export const  getLibraryTron = (provider_) => {
  let provider = provider_
  if (!provider || !provider.trx) {
    provider = window.tronWeb
  }
  const tronWeb = provider
  const getBlockNumber = async () => {
    const block = await tronWeb.trx.getCurrentBlock()
    return block.block_header.raw_data.number
  }
  const emitter = new EventEmitter()
  const on = (...args) => {
    emitter.on(...args as [string,any])
  }
  const removeListener = (...args) => {
    emitter.removeListener(...args  as [string,any])
  }
  const lookupAddress = async (...args) => {
    console.warn('library.lookupAddress() not implemented', args)
  }
  const getBalance = async address => {
    try {
      const balance = await tronWeb.trx.getBalance(toTronAddr(address))
      // console.log('getBalance', address, balance.toString())
      // console.log(`${address} balance is`, balance)
      return balance
    } catch (err) {
      console.error('error getting balance from tronweb', { address })
      throw err
    }
  }

  /*
   *  retry versioni
  const getTransactionReceipt = async hash => {
    const res = await promiseRetry(async retry => {
      console.log({ hash, tronWeb })
      const info = await tronWeb.trx.getTransactionInfo(hash)
      if (!info.id) {
        retry()
      }
      return info
    })
    console.log(res)
    return res
  }
  */

  const getTransactionReceipt = async hash => {
    const info = await tronWeb.trx.getTransactionInfo(hash)
    if (!info.id) {
      return null
    }
    return info
  }

  const toTronAddr = str => {
    return tronWeb.address.fromHex(`${str}`)
  }

  // poll for new blocks
  let lastBlockNumber
  setInterval(async () => {
    // query new block
    const block = await promiseRetry(async retry => {
      try {
        const b = await tronWeb.trx.getCurrentBlock()
        if (!b || !b.block_header || !b.block_header.raw_data) {
          return retry()
        }
        return b
      } catch (err) {
        console.error({ tronWeb, err })
        return retry()
      }
    })
    const blockNumber = block.block_header.raw_data.number
    if (lastBlockNumber !== blockNumber) {
      // console.log(`new block ${blockNumber}`, block)
      lastBlockNumber = blockNumber
      emitter.emit('block', block)
    }
  }, 1000)

  return {
    provider,
    getBlockNumber,
    getBalance,
    on,
    lookupAddress,
    removeListener,
    getTransactionReceipt,
    toTronAddr
  }
}
  

/**
 * BSC Wallet requires a different sign method
 * @see https://docs.binance.org/smart-chain/wallet/wallet_api.html#binancechainbnbsignaddress-string-message-string-promisepublickey-string-signature-string
 */
export const signMessage = async (provider: any, account: string, message: string): Promise<string> => {
  if (window.BinanceChain) {
    const { signature } = await window.BinanceChain.bnbSign(account, message)
    return signature
  }

  /**
   * Wallet Connect does not sign the message correctly unless you use their method
   * @see https://github.com/WalletConnect/walletconnect-monorepo/issues/462
   */
  if (provider.provider?.wc) {
    const wcMessage = ethers.utils.hexlify(ethers.utils.toUtf8Bytes(message))
    const signature = await provider.provider?.wc.signPersonalMessage([wcMessage, account])
    return signature
  }

  return provider.getSigner(account).signMessage(message)
}
